/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Style_Guide_Manager_Empty_StateInputs */

const en_style_guide_manager_empty_state = /** @type {(inputs: Style_Guide_Manager_Empty_StateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please create a new guide to start`)
};

const fr_style_guide_manager_empty_state = /** @type {(inputs: Style_Guide_Manager_Empty_StateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veuillez creer un nouveau guide pour commencer`)
};

const de_style_guide_manager_empty_state = /** @type {(inputs: Style_Guide_Manager_Empty_StateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bitte erstellen Sie eine neue Anleitung, um zu beginnen.`)
};

const it_style_guide_manager_empty_state = /** @type {(inputs: Style_Guide_Manager_Empty_StateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Per favore crea una nuova guida per iniziare`)
};

const ru_style_guide_manager_empty_state = /** @type {(inputs: Style_Guide_Manager_Empty_StateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пожалуйста, создайте новое руководство для начала.`)
};

const es_style_guide_manager_empty_state = /** @type {(inputs: Style_Guide_Manager_Empty_StateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por favor crea una nueva guía para comenzar`)
};

const zh_cn2_style_guide_manager_empty_state = /** @type {(inputs: Style_Guide_Manager_Empty_StateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`请创建新指南以开始`)
};

const ja_style_guide_manager_empty_state = /** @type {(inputs: Style_Guide_Manager_Empty_StateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`開始するには新しいガイドを作成してください`)
};

const hi_style_guide_manager_empty_state = /** @type {(inputs: Style_Guide_Manager_Empty_StateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कृपया शुरुआत करने के लिए एक नई गाइड बनाएं`)
};

const pt_pt2_style_guide_manager_empty_state = /** @type {(inputs: Style_Guide_Manager_Empty_StateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por favor, crie um novo guia para começar.`)
};

/**
* | output |
* | --- |
* | "Please create a new guide to start" |
*
* @param {Style_Guide_Manager_Empty_StateInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const style_guide_manager_empty_state = /** @type {((inputs?: Style_Guide_Manager_Empty_StateInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Style_Guide_Manager_Empty_StateInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_style_guide_manager_empty_state(inputs)
	if (locale === "de") return de_style_guide_manager_empty_state(inputs)
	if (locale === "it") return it_style_guide_manager_empty_state(inputs)
	if (locale === "ru") return ru_style_guide_manager_empty_state(inputs)
	if (locale === "es") return es_style_guide_manager_empty_state(inputs)
	if (locale === "zh-CN") return zh_cn2_style_guide_manager_empty_state(inputs)
	if (locale === "ja") return ja_style_guide_manager_empty_state(inputs)
	if (locale === "hi") return hi_style_guide_manager_empty_state(inputs)
	if (locale === "pt-PT") return pt_pt2_style_guide_manager_empty_state(inputs)
	return en_style_guide_manager_empty_state(inputs)
});